import {BLOGS_LOADING,SET_BLOGS} from './types';

const initialState = {
    loading:false,
    blogs:[]
};

export const reducer = (state=initialState,action) => {
    switch(action.type){
        case BLOGS_LOADING:
            return {
                ...state,
                loading:true
            }
        case SET_BLOGS:
            return {
                ...state,
                blogs:action.payload
            }
        default:
            return{
                ...state
            }
    }
}